var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.727,
    height: 69.72,
    viewBox: "0 0 69.727 69.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292929;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1275 -2241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.71,19.06a.991.991,0,0,1-.616-.213,22.718,22.718,0,0,0-11.226-4.664A1,1,0,0,1,39,13.029V3.14a1,1,0,0,1,.323-.737,1.022,1.022,0,0,1,.762-.259,34.635,34.635,0,0,1,19.388,8.02,1,1,0,0,1,.064,1.473l-7.116,7.127A1,1,0,0,1,51.71,19.06ZM41,12.323a24.714,24.714,0,0,1,10.612,4.411l5.726-5.726A32.608,32.608,0,0,0,41,4.247Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34,71.86h-.086A34.853,34.853,0,0,1,2.144,40.09a1,1,0,0,1,1-1.09H13a1.039,1.039,0,0,1,.774.189,1.022,1.022,0,0,1,.409.678,22.939,22.939,0,0,0,19.95,19.951A1,1,0,0,1,35,60.945V70.86A1,1,0,0,1,34,71.86ZM4.248,41A32.847,32.847,0,0,0,33,69.751V61.676A24.935,24.935,0,0,1,12.324,41Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.19,35.01a1.076,1.076,0,0,1-.159-.01H3.14a1,1,0,0,1-1-1.086A34.853,34.853,0,0,1,33.91,2.144a1,1,0,0,1,1.09,1V13a1.035,1.035,0,0,1-.188.775,1.024,1.024,0,0,1-.679.407,22.939,22.939,0,0,0-19.95,19.951,1,1,0,0,1-.993.877ZM4.248,33h8.076A24.935,24.935,0,0,1,33,12.324V4.249A32.847,32.847,0,0,0,4.248,33Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.78,60.16a1,1,0,0,1-.755-1.656c.647-.744,1.255-1.518,1.809-2.3a1,1,0,1,1,1.633,1.154c-.592.837-1.242,1.664-1.932,2.459a1,1,0,0,1-.755.343Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40,71.86a1,1,0,0,1-1-1V61a1.035,1.035,0,0,1,.188-.775,1.024,1.024,0,0,1,.679-.407,22.939,22.939,0,0,0,19.95-19.951A1,1,0,0,1,60.969,39H70.86a1,1,0,0,1,1,1.085,34.3,34.3,0,0,1-2.647,10.6,1,1,0,1,1-1.838-.788A32.3,32.3,0,0,0,69.753,41H61.676A24.935,24.935,0,0,1,41,61.676V69.75a33.16,33.16,0,0,0,7.493-1.808,1,1,0,1,1,.694,1.876,35.146,35.146,0,0,1-9.1,2.038C40.059,71.858,40.029,71.86,40,71.86Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.311,66.65a1,1,0,0,1-.537-1.845c.755-.479,1.511-1.009,2.309-1.619A1,1,0,0,1,58.3,64.774c-.845.647-1.648,1.209-2.453,1.721A1,1,0,0,1,55.311,66.65Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.841,35.013a1.033,1.033,0,0,1-1.024-.881,22.717,22.717,0,0,0-4.664-11.225,1,1,0,0,1,.08-1.324c.012-.012.1-.092.11-.1l7.02-7.017a1,1,0,0,1,1.474.065,34.632,34.632,0,0,1,8.019,19.387,1,1,0,0,1-1,1.085H61a1.055,1.055,0,0,1-.159.01ZM61.677,33h8.076a32.6,32.6,0,0,0-6.761-16.338l-5.725,5.726A24.727,24.727,0,0,1,61.677,33Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.5,47.794a.98.98,0,0,1-.161-.013c-19.058-3.091-20.32-18.757-20.33-18.914a1,1,0,1,1,2-.135h0c.041.58,1.207,14.246,18.654,17.075a1,1,0,0,1-.159,1.987Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.642,36.173a1,1,0,0,1-.884-1.466l3.368-6.377a1,1,0,0,1,1.351-.417l6.377,3.367a1,1,0,1,1-.934,1.768l-5.493-2.9-2.9,5.492A1,1,0,0,1,25.642,36.173Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.727,29.8a1,1,0,0,1-.707-1.707L43.113,24a1,1,0,1,1,1.414,1.414L40.434,29.5A1,1,0,0,1,39.727,29.8Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.82,29.8a1,1,0,0,1-.707-.293l-4.093-4.1A1,1,0,0,1,40.434,24l4.093,4.094A1,1,0,0,1,43.82,29.8Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.68,39.25a1,1,0,0,1-.707-1.707l4.093-4.094a1,1,0,1,1,1.414,1.414l-4.093,4.094A1,1,0,0,1,44.68,39.25Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.773,39.25a1,1,0,0,1-.707-.293l-4.093-4.094a1,1,0,1,1,1.414-1.414l4.093,4.094a1,1,0,0,1-.707,1.707Z",
    transform: "translate(1272.864 2238.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.32,50.3a4.094,4.094,0,1,1,4.094-4.1,4.094,4.094,0,0,1-4.094,4.1Zm0-6.188A2.094,2.094,0,1,0,30.414,46.2a2.094,2.094,0,0,0-2.094-2.088Z",
    transform: "translate(1272.864 2238.86)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.5a5896a599f4a6351162714478d2fdba.svg";
export { ForwardRef as ReactComponent };